import { Container } from 'inversify'
import { ErrorPlatformEvent, interpret } from 'xstate-v4'
import { rootContainer } from '~/container'
import {
  reportApiError,
  reportAppError,
} from '~/utility/sentry/apiErrorReporter'
import { CampsiteChargeTypesRepositoryFetch } from './CampsiteChargeTypesRepositoryFetch'
import { returnChargeTypesStateMachine } from './machines'
import { ChargeTypesInput } from './types'

export const campsiteDetailsContainer = new Container()
campsiteDetailsContainer.parent = rootContainer

export function getChargeTypesStateMachine(langCode: string) {
  return interpret(
    returnChargeTypesStateMachine().withConfig({
      services: {
        searchService: async ({
          params,
        }: {
          params: ChargeTypesInput | null
        }) => {
          if (!params) {
            throw new Error('no params')
          }
          const response = await new CampsiteChargeTypesRepositoryFetch().get(
            params,
            langCode,
          )
          return response.map((ct) => Object.freeze(ct))
        },
      },
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          const error = event.data

          // Use structured Sentry reporting for API errors
          if (
            error.name === 'ChargeTypesFetchError' ||
            error.name === 'ChargeTypesValidationError'
          ) {
            reportApiError(error, 'charge-types state machine', {
              stateMachineEvent: event.type,
              stateMachineName: 'chargeTypesStateMachine',
            })
          } else {
            // Handle unexpected errors
            reportAppError(error, 'charge-types state machine', {
              stateMachineEvent: event.type,
              stateMachineName: 'chargeTypesStateMachine',
              errorName: error.name || 'UnknownError',
            })
          }
        },
      },
    }),
  )
}
